import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//components
import { UpplmRouteMainComponent } from './components/routeMainComponent';
import { LocationsDetailsComponent } from './components/locationDetails/locationDetails.component';
import { ContactDetailsComponent } from './components/contactDetails/contactDetails.component';
import { PlacardDetailsComponent } from './components/placardDetails/placardDetails.component';
import { PickupDetailsComponent } from './components/pickupDetails/pickupDetails.component';
import { NotificationDetailsComponent } from './components/notificationDetails/notificationDetails.component';
import { ReviewComponent } from './components/review/review.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { PlacardExistsComponent } from './components/placardExists/placardExists.component';
import { PlacardVerificationComponent } from './components/placardVerification/placardVerification.component';
import { PlacardConfirmedComponent } from './components/placardConfirmed/placardConfirmed.component';
import { PlacardLocationComponent } from './components/placardLocation/placardLocation.component';
import { ApproveComponent } from './components/approve/approve.component';
import { ApproveConfirmedComponent } from './components/approveConfirmed/approveConfirmed.component';
import { PlacardExistsConfirmationComponent } from './components/placardExistsConfirmation/placardExistsConfirmation.component';
//Dashboard
import { TemplateDashboardComponent } from './components/templateDashboard/template-dashboard.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DefaultComponent } from './components/dashboard/default/default.component';
import { AdditionalDetailComponent } from './components/dashboard/additional-detail/additional-detail.component';
import { DispatchedComponent } from './components/dashboard/dispatched/dashboardDispatched.component';
import { Created1Component } from './components/dashboard/created1/dashboardCreated1.component';
import { Created2Component } from './components/dashboard/created2/dashboardCreated2.component';
import { Expired1Component } from './components/dashboard/expired1/dashboardExpired1.component';
import { RejectedAgedExpired2Component } from './components/dashboard/rejected-aged-expired2/rejected-aged-expired2.component';
import { CancelledComponent } from './components/dashboard/cancelled/dashboardCancelled.component';
import { PlacardAddClientKeyComponent } from './components/placardAddClientKey/placardAddClientKey.component';
import { PlacardAddClientKeyConfirmComponent } from './components/placardAddClientKey/confirm/placardAddClientKeyConfirm.component';

//QVDashboard
import { QVAdditionalDetailComponent } from './components/qvsummary/qvsummary-status/additional-detail/qvadditional-detail.component';
import { QVDispatchedComponent } from './components/qvsummary/qvsummary-status/dispatched/qvdashboardDispatched.component';
import { QVInactiveComponent } from './components/qvsummary/qvsummary-status/inactive/qvdashboardInactive.component';
import { QVCreated1Component } from './components/qvsummary/qvsummary-status/created1/qvdashboardCreated1.component';
import { QVCreated2Component } from './components/qvsummary/qvsummary-status/created2/qvdashboardCreated2.component';
import { QVExpired1Component } from './components/qvsummary/qvsummary-status/expired1/qvdashboardExpired1.component';
import { QVRejectedAgedExpired2Component } from './components/qvsummary/qvsummary-status/rejected-aged-expired2/qvrejected-aged-expired2.component';
import { QVCancelledComponent } from './components/qvsummary/qvsummary-status/cancelled/qvdashboardCancelled.component';

//QVDashboard Summary
import { qvsummaryComponent } from './components/qvsummary/qvsummary.component';
import { QvsummaryListComponent } from './components/qvsummary/qvsummary-list/qvsummary-list.component';
import { QVPlacardDetailComponent } from './components/qvsummary/qvPlacardDetail/qvPlacardDetail.component';

//controls and directives
import { UpsCacModule } from '@ews/cac';
import { upsProgressBarComponent } from './components/upsProgressBar/upsProgressBar.component';
import { UPSModalComponent } from './components/commonComponent/modal';
import { UpsDialogComponent } from './components/commonComponent/ups-dialog/ups-dialog.component';
import { UpsFileUploadComponent } from './components/commonComponent/ups-fileUpload/ups-fileUpload.component';
import { UpsDashboardAccordeonComponent } from './components/commonComponent/ups-dashboard-accordeon/ups-dashboard-accordeon.component';
import { UpsDashboardAccordeonQVComponent } from './components/commonComponent/ups-dashboard-accordeon-qv/ups-dashboard-accordeon-qv.component';
import { UpsDashboardAccordeonHeadComponent } from './components/commonComponent/ups-dashboard-accordeon-head/ups-dashboard-accordeon-head.component';
import { UpsDashboardAccordeonHeadQVComponent } from './components/commonComponent/ups-dashboard-accordeon-qv/ups-dashboard-accordeon-head-qv/ups-dashboard-accordeon-head-qv.component';
import { UpsDashboardAccordeonDetComponent } from './components/commonComponent/ups-dashboard-accordeon-det/ups-dashboard-accordeon-det.component';
import { UpsHamMenuComponent } from './components/commonComponent/ups-ham-menu/ups-ham-menu.component';
import { UpsHamMenuItemComponent } from './components/commonComponent/ups-ham-menu-item/ups-ham-menu-item.component';
import { UpsCardComponent } from './components/commonComponent/ups-card/ups-card.component';
import { UpsCardContentComponent } from './components/commonComponent/ups-card-content/ups-card-content.component';
import { UpsFilterComponent } from './components/commonComponent/ups-filter/ups-filter.component';
import { ReCaptchaDirective } from './directive/re-captcha.directive';
import { OnlyNumbers } from './directive/only-numbers.directive';
import { UpsResizeWindowComponent } from './components/commonComponent/ups-resize-window/ups-resize-window.component';
import { UPSOfficalDatePicker } from '../app/assets/angular/components/datepicker_official';
import { UPSBreadcrumb } from './components/commonComponent/ups-breadcrumb/breadCrumb';
import { UpsPageTitle } from './components/commonComponent/pageTitle';
import { UpsListComponent } from './components/commonComponent/ups-list/ups-list.component';
import { UpsListResizeComponent } from './components/commonComponent/ups-list/ups-list-resize/ups-list-resize.component';
import { UpsListHeadControlsComponent } from './components/commonComponent/ups-list/ups-list-head-controls/ups-list-head-controls.component';
import { UpsListFooterControlsComponent } from './components/commonComponent/ups-list/ups-list-footer-controls/ups-list-footer-controls.component';
import { UpsPaginationControlComponent } from './components/commonComponent/ups-pagination-control/ups-pagination-control.component';
import { UpsBarComponent } from './components/commonComponent/ups-bar/ups-bar.component';
import { UpsExportFileComponent } from './components/commonComponent/ups-export-file/ups-export-file.component';
import { TranslateDataPipe } from './pipes/translation.pipe';

// Placard Edition
import { EditLocationDetailsComponent } from './components/PlacardEdition/editLocationDetails/editLocationDetails.component';
import { NotificationChangesComponent } from './components/PlacardEdition/notificationChanges/notificationChanges.component';
import { UpsEmailInputComponent } from './components/commonComponent/ups-email-input/ups-email-input.component';
import { EditPickupDetailsComponent } from './components/PlacardEdition/editPickupDetails/editPickupDetails.component';
import { EditContactDetailsComponent } from './components/PlacardEdition/editContactDetails/editContactDetails.component';
import { EditNotificationDetailsComponent } from "./components/PlacardEdition/editNotificationDetails/editNotificationDetails.component";
import { EditPlacardLocationDetailsComponent } from './components/PlacardEdition/editPlacardLocationDetails/editPlacardLocationDetails.component';
import { EditPlacardDetailsComponent } from './components/PlacardEdition/editPlacardDetails/editPlacardDetails.component';
import { EditPlacardVerification } from './components/PlacardEdition/editPlacardVerification/editPlacardVerification.component';

// Pipes
import { RawTimePipe } from './pipes/formatRawTime.pipe';
import { FormatAmPmTimePipe } from './pipes/formatAmPmTime.pipe';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, UpsCacModule.forRoot()],
    declarations: [
        UpplmRouteMainComponent,
        upsProgressBarComponent,
        UpsExportFileComponent,
        LocationsDetailsComponent,
        PlacardLocationComponent,
        ContactDetailsComponent,
        PlacardDetailsComponent,
        PickupDetailsComponent,
        NotificationDetailsComponent,
        ReviewComponent,
        PlacardExistsComponent,
        PlacardConfirmedComponent,
        PlacardVerificationComponent,
        ConfirmationComponent,
        UPSModalComponent,
        UpsDialogComponent,
        UpsFileUploadComponent,
        UpsDashboardAccordeonComponent,
        UpsDashboardAccordeonQVComponent,
        UpsDashboardAccordeonHeadComponent,
        UpsDashboardAccordeonHeadQVComponent,
        UpsDashboardAccordeonDetComponent,
        UPSOfficalDatePicker,
        ReCaptchaDirective,
        OnlyNumbers,
        ApproveComponent,
        ApproveConfirmedComponent,
        DashboardComponent,
        TemplateDashboardComponent,
        DefaultComponent,
        DispatchedComponent,
        Created1Component,
        Created2Component,
        AdditionalDetailComponent,
        QVDispatchedComponent,
        QVInactiveComponent,
        QVCreated1Component,
        QVCreated2Component,
        QVAdditionalDetailComponent,
        UpsHamMenuComponent,
        UpsHamMenuItemComponent,
        UpsCardComponent,
        UpsCardContentComponent,
        UpsFilterComponent,
        UpsBarComponent,
        Expired1Component,
        RejectedAgedExpired2Component,
        QVExpired1Component,
        QVRejectedAgedExpired2Component,
        QVExpired1Component,
        QVRejectedAgedExpired2Component,
        CancelledComponent,
        QVCancelledComponent,
        PlacardAddClientKeyComponent,
        PlacardAddClientKeyConfirmComponent,
        PlacardExistsConfirmationComponent,
        UPSBreadcrumb,
        UpsPageTitle,
        UpsResizeWindowComponent,
        qvsummaryComponent,
        QvsummaryListComponent,
        UpsListComponent,
        UpsListResizeComponent,
        UpsListHeadControlsComponent,
        UpsListFooterControlsComponent,
        UpsPaginationControlComponent,
        QVPlacardDetailComponent,
        TranslateDataPipe,
        EditLocationDetailsComponent,
        NotificationChangesComponent,
        UpsEmailInputComponent,
        EditPickupDetailsComponent,
        EditContactDetailsComponent,
        EditNotificationDetailsComponent,
        EditPlacardLocationDetailsComponent,
        EditPlacardVerification,
        EditPlacardDetailsComponent,
        RawTimePipe,
        FormatAmPmTimePipe
    ],
    exports: [
        UpplmRouteMainComponent,
        upsProgressBarComponent,
        UpsExportFileComponent,
        LocationsDetailsComponent,
        PlacardLocationComponent,
        ContactDetailsComponent,
        PlacardDetailsComponent,
        PickupDetailsComponent,
        NotificationDetailsComponent,
        ReviewComponent,
        PlacardExistsComponent,
        PlacardConfirmedComponent,
        PlacardVerificationComponent,
        ConfirmationComponent,
        UPSModalComponent,
        UpsDialogComponent,
        UPSOfficalDatePicker,
        UpsFileUploadComponent,
        UpsDashboardAccordeonComponent,
        UpsDashboardAccordeonQVComponent,
        UpsDashboardAccordeonHeadComponent,
        UpsDashboardAccordeonHeadQVComponent,
        UpsDashboardAccordeonDetComponent,
        ApproveComponent,
        ApproveConfirmedComponent,
        DashboardComponent,
        TemplateDashboardComponent,
        DefaultComponent,
        DispatchedComponent,
        Created1Component,
        Created2Component,
        AdditionalDetailComponent,
        UpsHamMenuComponent,
        UpsHamMenuItemComponent,
        UpsCardComponent,
        UpsCardContentComponent,
        UpsFilterComponent,
        UpsBarComponent,
        Expired1Component,
        RejectedAgedExpired2Component,
        CancelledComponent,
        PlacardAddClientKeyComponent,
        PlacardAddClientKeyConfirmComponent,
        PlacardExistsConfirmationComponent,
        UPSBreadcrumb,
        UpsPageTitle,
        UpsResizeWindowComponent,
        qvsummaryComponent,
        QvsummaryListComponent,
        UpsListComponent,
        UpsListResizeComponent,
        UpsListHeadControlsComponent,
        UpsListFooterControlsComponent,
        UpsPaginationControlComponent,
        QVPlacardDetailComponent,
        EditLocationDetailsComponent,
        NotificationChangesComponent,
        UpsEmailInputComponent,
        EditPickupDetailsComponent,
        EditContactDetailsComponent,
        EditNotificationDetailsComponent,
        EditPlacardLocationDetailsComponent,
        EditPlacardVerification,
        EditPlacardDetailsComponent
    ],
    entryComponents: [
        UpplmRouteMainComponent,
        upsProgressBarComponent,
        LocationsDetailsComponent,
        ContactDetailsComponent,
        PlacardDetailsComponent,
        PickupDetailsComponent,
        NotificationDetailsComponent,
        ReviewComponent,
        PlacardExistsComponent,
        PlacardConfirmedComponent,
        PlacardVerificationComponent,
        UPSOfficalDatePicker,
        ConfirmationComponent,
        ApproveComponent,
        ApproveConfirmedComponent,
        DashboardComponent,
        TemplateDashboardComponent,
        DefaultComponent,
        DispatchedComponent,
        Created1Component,
        Created2Component,
        AdditionalDetailComponent,
        Expired1Component,
        RejectedAgedExpired2Component,
        CancelledComponent,
        PlacardAddClientKeyComponent,
        PlacardAddClientKeyConfirmComponent,
        PlacardExistsConfirmationComponent,
        qvsummaryComponent,
        QvsummaryListComponent,
        QVPlacardDetailComponent,
        EditLocationDetailsComponent,
        NotificationChangesComponent,
        UpsEmailInputComponent,
        EditPickupDetailsComponent,
        EditContactDetailsComponent,
        EditNotificationDetailsComponent,
        EditPlacardLocationDetailsComponent,
        EditPlacardVerification,
        EditPlacardDetailsComponent
    ],
    providers: [TranslateDataPipe, DatePipe, RawTimePipe, FormatAmPmTimePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})


export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule
        };
    }
}
